import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getMobileTheme, ScopedThemeProvider, useDevice } from 'seagull';
import { AppDeviceProvider } from '~/providers/DeviceProvider';
function ScaledDownFontsOnMobile(param) {
    let { children, maxHeight = true } = param;
    const { isMobileDevice } = useDevice();
    return isMobileDevice ? /*#__PURE__*/ _jsx(ScopedThemeProvider, {
        theme: getMobileTheme(),
        maxHeight: maxHeight,
        maxWidth: true,
        children: children
    }) : /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
}
export function MobileDeviceEnhancer(param) {
    let { children, enabled = true, maxHeight = true } = param;
    if (!enabled) {
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(AppDeviceProvider, {
        children: /*#__PURE__*/ _jsx(ScaledDownFontsOnMobile, {
            maxHeight: maxHeight,
            children: children
        })
    });
}
